<div class="footer-at-bottom-wrapper">
	<app-header></app-header>

	<div class="layout">
	  <div class="content content--centered">
	    <router-outlet></router-outlet>
	  </div>
	</div>

	<app-footer class="footer-at-bottom"></app-footer>
</div>


